module.exports = __webpack_public_path__ + "images/nedasco_small0e819f067f9654a9ea645b1104ab20b7.png";